import { staffToneOf } from '../../core/rules/staffColors';
import { staffById } from '../../core/rules/salonDays';
import type { StaffProfile } from '../../core/types/site';
type Props = {
  staff: readonly StaffProfile[];
  id: string | undefined;
  /** `sm` = op een agendablok; `md` = in een lijst of het detail. */
  size?: 'sm' | 'md';
  className?: string;
};

/** Rondje met de initialen van de uitvoerder, in haar agendakleur. De naam staat er altijd als tekst naast of in het label. */
export function StaffDot({
  staff,
  id,
  size = 'md',
  className = ''
}: Props) {
  const s = staffById(staff, id);
  const tone = staffToneOf(staff, id);
  const dim = size === 'sm' ? 'h-4 min-w-[1rem] px-0.5 text-[9px]' : 'h-6 min-w-[1.5rem] px-1 text-[11px]';
  return <span className={`inline-flex shrink-0 items-center justify-center rounded-full font-medium leading-none ${dim} ${tone.dot} ${className}`} aria-hidden="true" data-id="element-519" data-mp="1y0g09ksuhq5j">
      {s?.initials ?? '?'}
    </span>;
}